import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * Samme sidehoved på alle admin-sider: titel til venstre, kort forklaring under, handlinger til højre.
 * Brug den i stedet for egne <h1>/<Typography variant="h4" align="center"> pr. side.
 */
const PageHeader = ({ title, description, actions }: { title: string; description?: ReactNode; actions?: ReactNode }) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, mb: 3, flexWrap: "wrap" }}>
    <Box sx={{ minWidth: 240 }}>
      <Typography variant="h1" component="h1">
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 720 }}>
          {description}
        </Typography>
      )}
    </Box>
    {actions && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>{actions}</Box>}
  </Box>
);

export default PageHeader;
